export const createModule = (factory) => {
    return (transports) => {
        return factory(transports);
    };
};
